import { faPause, faPlay, faRepeat } from "@fortawesome/pro-regular-svg-icons";
import { useMp3Player } from "../../../../../../../Util/hooks/useMp3Player";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import secondsToTimeString from "../../../../../../../Util/functions/secondsToTimeString";

const MessageMp3Player = ({
  mp3Id,
  mp3FileUrl,
  audioControlsDisabled,
  showTopBorder,
}) => {
  const {
    isPlaying,
    play,
    pause,
    seek,
    audioDuration,
    currentTime,
    isEnded,
    currentPlaybackPosition,
  } = useMp3Player(mp3Id, mp3FileUrl);

  const togglePlayAudio = () => {
    if (isPlaying) {
      pause();
    } else {
      play();
    }
  };

  return (
    <div
      className="chatHistoryAudioContainer"
      style={{
        borderTop: showTopBorder ? "1px solid white" : "none",
        paddingTop: showTopBorder ? "8px" : "0px",
      }}
    >
      <button onClick={togglePlayAudio} disabled={audioControlsDisabled}>
        <FontAwesomeIcon
          icon={isEnded ? faRepeat : isPlaying ? faPause : faPlay}
        />
      </button>
      <p>{secondsToTimeString(currentTime)}</p>
      <div className="chatHistoryAudioProgressBar">
        <input
          className="chatHistoryAudioProgressBarInput"
          type="range"
          min={0}
          max={100}
          value={currentPlaybackPosition}
          onChange={(e) => {
            seek(e.target.value);
          }}
          disabled={audioControlsDisabled}
        />
      </div>
      <p>{secondsToTimeString(audioDuration)}</p>
    </div>
  );
};

export default MessageMp3Player;
